import React, { useState } from 'react';
import QuestionLabel from './QuestionLabel';
import mailcheck from 'mailcheck';
import { debounce } from '../../../lib/Utils.js';
import EmailInput from '../../EmailInput.jsx';

const EmailQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <EmailInput value={value} onChange={setValue} />
        </label>
    );
};

export default EmailQuestion;
